const { loadChatBot } = require('./src/utils/chatbot');

exports.shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash || location.pathname.includes('article')) {
    const currentPosition = getSavedScrollPosition(location);
    setTimeout(() => {
      sessionStorage.setItem(
        `@@scroll|${location.pathname}|initial`,
        currentPosition[1],
      );
    }, 0);
  }
  if (location.pathname === '/pricing') {
    return !location.search;
  }
};
exports.onClientEntry = () => {
  applyTheme(window.location.pathname);
};

exports.onInitialClientRender = () => {
  let chatbotInitialized = false;

  const initChatbot = () => {
    if (chatbotInitialized) return;
    chatbotInitialized = true;
    loadChatBot();
  };

  // Option 1: After scroll
  window.addEventListener('scroll', initChatbot, { once: true });

  // Option 2: After 10s delay
  setTimeout(initChatbot, 10000);

  // Option 3: On user click anywhere
  window.addEventListener('click', initChatbot, { once: true });
};

function applyTheme(pathname) {
  let theme = 'dark';
  const isBlog = pathname === '/blog' || pathname.startsWith('/blog/');

  if (isBlog) {
    try {
      const blogTheme = localStorage.getItem('blog-theme');
      if (blogTheme === 'dark' || blogTheme === 'light') {
        theme = blogTheme;
      }
    } catch {
      /* empty */
    }
  }

  document.documentElement.setAttribute('data-theme', theme);
}
